import {all, fork, put, takeEvery} from "redux-saga/effects";

import {ADD_TO_CART, CLEAR_CART, GET_CART, REMOVE_FROM_CART} from "./actionTypes";
import {cartUpdated} from "./actions";

function* addToCartSaga({payload: {product, invest}}) {
    const cartItems = JSON.parse(sessionStorage.getItem("cart")) || [];
    const newCartItems = cartItems.filter(ci => ci.product.id !== product.id);
    newCartItems.push({product, invest});
    sessionStorage.setItem("cart", JSON.stringify(newCartItems));
    yield put(cartUpdated(newCartItems));
}

function* removeFromCartSaga({payload: {product}}) {
    const cartItems = JSON.parse(sessionStorage.getItem("cart")) || [];
    const newCartItems = cartItems.filter(ci => ci.product.id !== product.id);
    sessionStorage.setItem("cart", JSON.stringify(newCartItems));
    yield put(cartUpdated(newCartItems));
}

function* clearCartSaga({payload: {product}}) {
    sessionStorage.setItem("cart", JSON.stringify([]));
    yield put(cartUpdated([]));
}

function* getCartSaga() {
    const cartItems = JSON.parse(sessionStorage.getItem("cart")) || [];
    yield put(cartUpdated(cartItems));
}

export function* watchAddToCartSaga() {
    yield takeEvery(ADD_TO_CART, addToCartSaga);
}

export function* watchRemoveFromCartSaga() {
    yield takeEvery(REMOVE_FROM_CART, removeFromCartSaga);
}

export function* watchClearCartSaga() {
    yield takeEvery(CLEAR_CART, clearCartSaga);
}

export function* watchGetCartSaga() {
    yield takeEvery(GET_CART, getCartSaga);
}

function* cartSaga() {
    yield all([
        fork(watchAddToCartSaga),
        fork(watchRemoveFromCartSaga),
        fork(watchClearCartSaga),
        fork(watchGetCartSaga)
    ]);
}

export default cartSaga;
